import { CookieSettingsLink } from "@/components/legal/CookieConsent";
import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { TermsContent } from "@/components/legal/TermsContent";

export default function Terms() {
  const { hash } = useLocation();
  useEffect(() => { if (hash) document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }); }, [hash]);
  return (
    <div data-testid="terms-page" className="min-h-screen bg-[#050505] text-white">
      <header className="border-b border-[#2A2A2A] px-6 h-16 flex items-center justify-between max-w-4xl mx-auto">
        <Logo />
        <Link to="/sign-up" className="text-sm text-[#00FF9D] hover:underline">Create account</Link>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-display text-4xl sm:text-5xl font-semibold">Terms of Service &amp; Privacy Policy</h1>
        <div className="mt-6"><TermsContent /></div>
        <p className="mt-10 text-xs font-mono text-[#A3A3A3]"><CookieSettingsLink testid="terms-cookie-settings" /></p>
      </main>
    </div>
  );
}
